export const CATEGORIES_STARTED = 'CATEGORIES_STARTED';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_FAILED = 'CATEGORIES_FAILED';
